import { render } from "./Checklist.vue?vue&type=template&id=b2179d64&scoped=true"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"

import "./Checklist.vue?vue&type=style&index=0&id=b2179d64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2179d64"]])

export default __exports__